import { t } from 'ttag';

export const ErrorMessages = () => ({
    // TRANS: Error messages (usually shown in top notification bar)
    'Refresh token data is invalid': t`ERR_MSG_SESSION_EXPIRED`,
    'Refresh token is expired': t`ERR_MSG_SESSION_EXPIRED`,
    'Token is expired!': t`ERR_MSG_SESSION_EXPIRED`,
    EMAIL_INVALID: t`EMAIL_INVALID`,
    EMAIL_TAKEN: t`EMAIL_TAKEN`,
    ERROR_USERNAME_ALREADY_EXISTS: t`ERROR_USERNAME_ALREADY_EXISTS`,
    GENERAL_ERROR: t`GENERAL_ERROR`,
    INCORRECT_CREDENTIALS: t`INCORRECT_CREDENTIALS`,
    NETWORK_ERROR: t`NETWORK_ERROR`,
    PRH_API_EXCEPTION: t`(ERR_MSG)_PRH_API_EXCEPTION`,
    PRH_API_PERMISSION_DENIED: t`(ERR_MSG)_PRH_API_PERMISSION_DENIED`,
    PRH_API_SERVER_EXCEPTION: t`(ERR_MSG)_PRH_API_SERVER_EXCEPTION`,
    PRH_BROKEN: t`(ERR_MSG)_PRH_BROKEN`,
    REFRESH_TOKEN_DATA_INVALID: t`ERR_MSG_SESSION_EXPIRED`,
    REFRESH_TOKEN_EXPIRED: t`ERR_MSG_SESSION_EXPIRED`,
    ROUTE_NOT_FOUND: t`ROUTE_NOT_FOUND`,
    TRAFICOM_API_EXCEPTION: t`ERR_MSG_TRAFICOM_BROKEN`,
    TRAFICOM_API_OWNER_RESTRICTED: t`TRAFICOM_API_OWNER_RESTRICTED`,
    TRAFICOM_API_PERMISSION_DENIED: t`TRAFICOM_API_PERMISSION_DENIED`,
    TRAFICOM_API_VEHICLE_NOT_FOUND: t`(ERR_MSG)_TRAFICOM_API_VEHICLE_NOT_FOUND`,
    TRAFICOM_BROKEN: t`ERR_MSG_TRAFICOM_BROKEN`,
    undefined: t`GENERAL_ERROR`,
    USER_NOT_FOUND: t`USER_NOT_FOUND`,
    USER_WAS_NOT_VERIFIED: t`USER_WAS_NOT_VERIFIED`,
    GETTING_BATTERY_MARKET_LIST: t`(ERR_MSG)_GETTING_BATTERY_MARKET_LIST`,
    MAKING_BATTERY_BID: t`(ERR_MSG)_MAKING_BATTERY_BID`,
    GETTING_ADDED_BATTERY_LIST: t`(ERR_MSG)_GETTING_ADDED_BATTERY_LIST`,
});

export const SuccessMessages = () => ({
    // TRANS: Success messages (usually shown in top notification bar)
    GENERAL_SUCCESS: t`GENERAL_SUCCESS`,
    PROFILE_UPDATED: t`PROFILE_UPDATED`,
    ADDRESS_CREATED: t`ADDRESS_CREATED`,
    ADDRESS_UPDATED: t`ADDRESS_UPDATED`,
    ADDRESS_DELETED: t`ADDRESS_DELETED`,
});
